import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import xlsx from "xlsx";
import $ from "jquery";

import { Translate, I18n } from "react-redux-i18n";

import ChoiceModal from "../../utils/components/ChoiceModal";

import {
  momentModule,
  prepareStatsCSVDownload,
  roundToDecimals,
  getPlug,
  parseAddress,
  isValidDurationCdr,
} from "../../utils/Utils";

import battery from "../../../styles/images/battery_grey.svg";
import download from "../../../styles/images/download.svg";

const { moment, formatDate } = momentModule;

class Sessions extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      pageNumber: 1,
      withVat: false,
      sessions: [],

      modals: {
        choice: false,
      },
    };

    this.handleOnChangeWithVat = this.handleOnChangeWithVat.bind(this);
    this.handleOnChoose = this.handleOnChoose.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    if (this.props.sessionCount > 0) this.fetchSessions();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps?.mode !== this.props.mode ||
      prevProps?.from !== this.props.from ||
      prevProps?.to !== this.props.to ||
      prevProps?.evId !== this.props.evId ||
      prevProps?.driverId !== this.props.driverId ||
      prevProps?.charger !== this.props.charger ||
      prevProps?.sessionCount !== this.props.sessionCount
    ) {
      if (this.props.sessionCount > 0) this.fetchSessions();
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  fetchSessions() {
    const buildFilterPacket = () => {
      if (this.props.mode === "ev")
        return {
          evId: this.props.evId,
          driverId: this.props.driverId,
        };
      else {
        const { infrastructure, hwId } = this.props.charger;
        return { infrastructure, hwId };
      }
    };

    axios
      .get("/api/private/history_v2", {
        cancelToken: new CancelToken((c) => (this.cancelHistory = c)),
        params: {
          type: `${this.props.mode}s`,
          startDate: new Date(this.props.from),
          endDate: new Date(this.props.to),
          pageNumber: this.state.pageNumber,
          limiteQuery: 10,
          filter: buildFilterPacket(),
        },
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({ sessions: res.data });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleOnChangeWithVat(e) {
    const withVat = e.target.checked;
    this.safeSetState({ withVat });
  }

  handleOnChoose(idx, _obj) {
    this.setModal("choice", false);
    const { mode, from, to } = this.props;

    //Deep copy is necessary. JSON Parse/Stringify does the job.
    const data = JSON.parse(JSON.stringify(this.state.sessions));
    const newData = [];

    //Data manipulation to display only the necessary and correct data
    data.forEach((item) => {
      const exportItem = {
        date: item.startDate,
        fleet: (item.fleet && item.fleet.name) || "-",
        ev: item.ev?.licensePlate ?? "-",
        [mode === "charger" ? "infrastructure" : "group"]:
          mode === "charger"
            ? item.infrastructure && item.infrastructure.name
            : item.user && item.user._id === this.props.accountData.id
            ? "-"
            : item.groupDrivers
            ? item.groupDrivers.name || "-"
            : I18n.t("history_other"),
        charger: item.charger && item.charger.name,
        location: parseAddress(item.charger.address),
        user:
          typeof item.user === "object"
            ? item.user?.name ?? "-"
            : I18n.t(`history_${mode === "charger" ? "public" : "other"}`),
        timeCharged: moment
          .duration(item.timeCharged, "hours")
          .format("h[h] m[m] s[s]"),
        totalEnergy: item.totalPower,
        co2Emitted: item.CO2Saved,
        [`${mode === "ev" ? `spent` : "earnings"}${
          this.state.withVat ? "_inclVat" : "_exclVat"
        }`]:
          item.totalPrice &&
          !Number.isNaN(
            item.totalPrice[this.state.withVat ? "incl_vat" : "excl_vat"]
          )
            ? `${roundToDecimals(
                item.totalPrice[this.state.withVat ? "incl_vat" : "excl_vat"],
                2
              )} €`
            : "-",
        hardwareId: item.hwId,
      };

      newData.push(exportItem);
    });

    if (idx === 0) {
      // csv
      const download = prepareStatsCSVDownload(
        "history",
        newData,
        from,
        to,
        this.props.brand.brandTitle
      );
      $("#downloadFile").append(download);
      download.click();
      $("#downloadFile").remove(download);
    } else if (idx === 1) {
      let wb = xlsx.utils.book_new();
      const sheetName = `${moment(from).format("DD-MM-YYYY")}_${moment(
        to
      ).format("DD-MM-YYYY")}`;
      wb.SheetNames.push(sheetName);
      let ws = xlsx.utils.json_to_sheet(
        newData.map((s) => {
          delete s._id;
          delete s.evId;
          delete s.carImage;
          return s;
        })
      );
      wb.Sheets[sheetName] = ws;
      xlsx.writeFile(
        wb,
        `${this.props.brand.brandTitle}_${I18n.t(
          "insights_historyTabTitle"
        )}_${sheetName}.xlsx`
      );
    }
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    if (this.state.sessions.length === 0) return null;
    return (
      <div id={`${this.props.mode}Sessions`} className="highlight-container">
        <div className="highlight-container-header">
          <img src={battery} alt="" />
          <Translate value="insightsByCar_mostRecentSessions" />
          <button
            type="button"
            className="export-btn"
            onClick={() => this.setModal("choice", true)}
          >
            <img src={download} alt="" />
            <Translate value="insightsByCharger_export" />
          </button>
        </div>
        <div className="highlight-container-body">
          <div className="table-container">
            <div className="table-header">
              <div className="row no-gutters">
                <div className="col-12 row no-gutters titles">
                  <div className="col title">
                    <Translate value="insightsByCharger_date" />
                  </div>
                  <div className="col-1 title">
                    <Translate value="insightsByCharger_chargingTime" />
                  </div>
                  <div className="col-1 title">
                    <Translate value="insightsByCharger_energy" />
                  </div>
                  {this.props.mode === "ev" ? (
                    <div className="col title">
                      <Translate value="insightsByCharger_hwId" />
                    </div>
                  ) : (
                    <div className="col title">
                      <Translate value="insightsByCharger_ev" />
                    </div>
                  )}
                  {this.props.mode === "ev" && (
                    <div className="col title">
                      <Translate value="insightsByCharger_location" />
                    </div>
                  )}
                  <div className="col title">
                    <Translate value="insightsByCharger_user" />
                  </div>
                  <div className="col title">
                    <Translate value="insightsByCharger_network" />
                  </div>
                  {this.props.mode === "charger" && (
                    <div className="col title">
                      <Translate value="insightsByEV_cost" />(
                      <label htmlFor="withVat">
                        <Translate value="history_withVat" />
                      </label>
                      <input
                        id="withVat"
                        type="checkbox"
                        checked={this.state.withVat}
                        onChange={this.handleOnChangeWithVat}
                      />
                      )
                    </div>
                  )}
                  {this.props.mode === "ev" ? (
                    <div className="col title">
                      <Translate value="insightsByEV_cost" />(
                      <label htmlFor="withVat">
                        <Translate value="history_withVat" />
                      </label>
                      <input
                        id="withVat"
                        type="checkbox"
                        checked={this.state.withVat}
                        onChange={this.handleOnChangeWithVat}
                      />
                      )
                    </div>
                  ) : (
                    <div className="col title">
                      <Translate value="insightsByCharger_spent" />(
                      <label htmlFor="withVat">
                        <Translate value="history_withVat" />
                      </label>
                      <input
                        id="withVat"
                        type="checkbox"
                        checked={this.state.withVat}
                        onChange={this.handleOnChangeWithVat}
                      />
                      )
                    </div>
                  )}
                  <div className="col-1 title">
                    <Translate value="insightsByCharger_plug" />
                  </div>
                </div>
              </div>
            </div>
            <div className="table-values">
              {this.state.sessions.map((stat) => {
                const duration = moment.duration(stat.timeCharged, "hours");

                return (
                  <div key={stat.startDate} className="row no-gutters">
                    <div className="col-12 row no-gutters values slim">
                      <div className="col">
                        {formatDate(stat.startDate, "datetime")}
                      </div>
                      <div className="col-1">
                        {duration.format("h[h] m[m] s[s]")}
                      </div>
                      <div className="col-1">
                        {stat.totalPower > 1
                          ? `${roundToDecimals(
                              stat.totalPower,
                              stat.totalPower > 9 ? 1 : 3
                            )}kWh`
                          : `${roundToDecimals(
                              stat.totalPower * 1000,
                              stat.totalPower * 1000 > 9 ? 1 : 3
                            )}Wh`}
                      </div>
                      {this.props.mode === "ev" ? (
                        <div className="col">{stat.charger?.hwId || "-"}</div>
                      ) : (
                        <div className="col">
                          {stat.ev?.licensePlate || "-"}
                        </div>
                      )}

                      {this.props.mode === "ev" && (
                        <div className="col">
                          {parseAddress(stat.charger?.address)}
                        </div>
                      )}

                      <div className="col">{stat.user?.name || "-"}</div>
                      <div className="col">
                        {stat.charger?.network === "history_internalNetwork" ? (
                          <Translate value={stat.charger?.network} />
                        ) : (
                          stat.charger?.network ?? "-"
                        )}
                      </div>
                      {this.props.mode === "charger" && (
                        <div className="col">{`${roundToDecimals(
                          stat.purchaseTariffDetails[
                            this.state.withVat ? "incl_vat" : "excl_vat"
                          ],
                          2
                        )}€`}</div>
                      )}
                      <div className="col">
                        {isValidDurationCdr(stat, "hours")
                          ? "-"
                          : stat.totalPrice &&
                            !Number.isNaN(
                              stat.totalPrice[
                                this.state.withVat ? "incl_vat" : "excl_vat"
                              ]
                            )
                          ? `${roundToDecimals(
                              stat.totalPrice[
                                this.state.withVat ? "incl_vat" : "excl_vat"
                              ],
                              2
                            )}€`
                          : "-"}
                      </div>
                      <div className="col-1">
                        <img
                          className="plug-icon"
                          src={
                            getPlug(
                              stat.charger?.plugs?.find(
                                (plug) => plug.plugId === stat.plugId
                              )?.connectorType
                            )?.plug ?? getPlug("noplug")
                          }
                          alt="plug"
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <ChoiceModal
          show={this.state.modals.choice}
          onHide={() => this.setModal("choice", false)}
          choices={[
            { content: "XLSX", name: "xlsx" },
            { content: "CSV", name: "csv" },
          ]}
          chooseBtnLabel="insightsByCharger_export"
          onChoose={this.handleOnChoose}
        />

        <div id="downloadFile" style={{ visibility: "hidden" }} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  accountData: state.account.accountData,
  brand: state.app.brand,
});

export default connect(mapStateToProps, null)(Sessions);
